module.exports = __webpack_public_path__ + "img/4_41.2c28700f.png";